export interface IMatchDeadline {
    id: number,
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    donorCenterId: number,
    donorCenter: string,
    donorId: number,
    donorAlias: string,
    recipientCenterId: number,
    recipientCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientAvoids: number,
    deadlineDateTime: string
}